import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { ModuleRoute } from '@core/router/types';
import { Permissions } from '@core/auth/permissions';

// Lazy-loaded page components for code splitting
const UserListPage = lazy(() => import('./pages/UserListPage'));
const UserFormPage = lazy(() => import('./pages/UserFormPage'));

// Placeholder pages - to be implemented later
const UserRolesPage = () => <div>User Roles Page - To be implemented</div>;
const UserPermissionsPage = () => <div>User Permissions Page - To be implemented</div>;

/**
 * Users Module Routes
 *
 * All routes are relative to /users base path.
 * Routes with permission prop require that permission to access.
 * 
 * This module handles:
 * - User management (create, update, archive users)
 * - Role management (assign roles to users)
 * - Permission management (assign permissions to users/roles)
 */
export const usersRoutes: ModuleRoute[] = [
  // Default redirect to user list
  {
    index: true,
    element: <Navigate to="lista" replace />,
  },

  // User List (Korisnici)
  {
    path: 'lista',
    element: <UserListPage />,
    permission: Permissions.Users.Users.Read,
    meta: {
      title: 'Korisnici',
      icon: 'People',
      showInSidebar: true,
      order: 1,
    },
  },

  // Create User
  {
    path: 'novi',
    element: <UserFormPage />,
    permission: Permissions.Users.Users.Create,
    meta: {
      title: 'Novi korisnik',
      showInSidebar: false,
    },
  },

  // Edit User
  {
    path: ':id/izmeni',
    element: <UserFormPage />,
    permission: Permissions.Users.Users.Update,
    meta: {
      title: 'Izmeni korisnika',
      showInSidebar: false,
    },
  },

  // Roles (Uloge) - To be implemented later
  {
    path: 'uloge',
    element: <UserRolesPage />,
    permission: Permissions.Users.Roles.Read,
    meta: {
      title: 'Uloge',
      icon: 'Security',
      showInSidebar: true,
      order: 2,
    },
  },

  // Permissions (Permisije) - To be implemented later
  {
    path: 'permisije',
    element: <UserPermissionsPage />,
    permission: Permissions.Users.Permissions.Assign,
    meta: {
      title: 'Permisije',
      icon: 'VpnKey',
      showInSidebar: true,
      order: 3,
    },
  },
];

